import { createStore } from "vuex";
import VuexPersist from 'vuex-persist'
window.g25cache = window.g25cache || {}
const vuexPersist = new VuexPersist({ key: 'genoplot-persist', storage: sessionStorage })
import genoVersion from './genoVersion.json'
const genoVer = genoVersion.version
import jsonstrings from './jsonstrings.json'
function deepFreeze(obj) {
  if (typeof obj === 'object' && obj !== null) {
    if (Array.isArray(obj)) {
      obj.forEach(element => {
        if (typeof element === 'object' && element !== null) {
          deepFreeze(element); // Recursively freeze array elements
        }
      });
    } else {
      Object.getOwnPropertyNames(obj).forEach(prop => {
        const value = obj[prop];
        if (typeof value === 'object' && value !== null) {
          deepFreeze(value);
        }
      });
    }
    return Object.freeze(obj);
  }
  return obj;
}

var settings = {
    slider: {
        limit: {
            value: 'OFF',
            data: [
                ['OFF', 3, 4, 5, 6, 7, 8]
            ]
        },
        min: {
            value: '0%',
            data: [
                ['0%', '1%', '2%']
            ]
        },
        batches: {
            value: 200,
            data: [
                [100, 200, 400, 500, 600, 800, 1000],
                [100, 200, 300, 400, 500]
            ]
        },
        cycles: {
            value: 200,
            data: [
                [100, 200, 400, 500, 600, 800, 1000],
                [100, 200, 300, 400, 500]
            ]
        },
        maxfits: {
            value: 20,
            data: [
                [20, 100, 200, 500, 600, 800, 1000],
                [20, 30, 40, 50, 60, 80, 90, 100]
            ]
        },
        colors: {
            value: "1",
            data: ["1", "2", "3", "4", "5"]
        },
        layout: {
            value: "Chart",
            data: ["Chart", "Data", "Both"]
        },
        theme: {
            value: "system",
            data: ["system", "light", "dark"]
        }
    },
    switches: {
        defaultOn: true,
        defaultOff: false,
        scaled: true,
        paidPlan: true,
        calculator: false,
        basePlan: false,
        custom: true,
        editPCA: false,
        ancient: false,
        removeOutliers: false,
        penalty: true,
        groupAveraged: false,
        groupMedian: false,
        optimaFit: false,
        groupSamples: false,
        lite: false,
    }
}
var data = {
    labsPrimaryTab: 'maps',
    frontpageLoaded: false,
    mfalogin: false,
    scriptLoaded: false,
    mfaUser: null,
    cached: Date.now(),
    simMaps: {},
    groupedSamples: true,
    g25Loaded: false,
    pcaLoaded: false,
    admixLoaded: false,
    fstatsLoaded: false,
    customCSV: '',
    genod: false,
    G25calc: false,
    intercomhash: false,
    discussLoaded: false,
    navLoaded: false,
    imageSource: '',
    contacted: false,
    dftemp: false,
    dfsid: false,
    alias: false,
    genolabs: false,
    showlab: false,
    avatarImage: false,
    settings: settings,
    authState: 'signIn',
    netError: false,
    userdata: false,
    showshare: false,
    proxyUser: false,
    sharedurl: false,
    xflipped: false,
    yflipped: false,
    genoVer: genoVer,
    isMobile: false,
    topClass: false,
    customgroups: [],
    peeruser: false,
    subscribed: false,
    activeModal: '',
    activePage: 'landing',
    annotationText: '',
    searchPCA: '',
    g25firstRun: true,
    graphQLurl: false,
    primaryTabs: "",
    usergroups: [],
    isAdmin: false,
    secondaryTabs: "",
    onLine: true,
    activePane: 'chart',
    checkFitsData: [],
    changes: {},
    calcChanges: {},
    themes: ['alice', 'jade', 'ruby', 'kelly', 'indigo'],
    credits: 0,
    env: window.location.hostname.split('.')[0] === "staging" ? 'staging' : window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname === '0.0.0.0' || window.location.hostname == 'dev.genoplot.com' || window.location.hostname == '192.168.86.39' || window.location.hostname.substr(0,3) == '10.' ? 'development' : 'production',
    currentIndex: 0,
    activeCalcIndex: 0,
    activeOwnerIndex: 0,
    subId: false,
    editedImageUrl: '',
    editedImageUrl2: '',
    editingImage: false,
    statusMessage: '',
    g25Rerun: false,
    pcaRerun: false,
    g25expand: 0,
    theme: false,
    fadeIn: false,
    showGrid: 0,
    chartType: 'radialBar',
    geo: {},
    target: false,
    user: sessionStorage.getItem('user'),
    monteMode: 'G25',
    g25customSamples: [],
    pcacustomSamples: [],
    pcadata: {},
    lastSort: false,
    lastQuery: false,
    spinner: false,
    cbInstance: false,
    subscription: false,
    subsActive: false,
    sampleArray: [],
    rawArray: [],
    progress: 0,
    lastsync: false,
    screenWidth: 1280,
    screenHeight: 1024,
    saveReady: false,
    queryTimeStamp: 0,
    groupArray: [],
    mapSampleArray: [],
    calcGroupsArray: [],
    mapGroupArray: [],
    mapCalcGroupsArray: [],
    mapchartJSON: false,
    mapheatmapJSON: false,
    mapcalcJSON: '',
    mapchartColors: false,
    mapcalcColors: false,
    mapchartCategories: [],
    mapchartLoading: false,
    mapchartRunning: false,
    mapchartSeries: [],
    mapcalcSeries: [],
    mapcalcSampleSeries: [],
    mapcalcSampleComponents: [],
    mapcalcComponents: [],
    mapchartComponents: [],
    calcArray: [],
    g25chartJSON: false,
    g25heatmapJSON: false,
    g25calcJSON: false,
    g25chartColors: false,
    g25calcColors: false,
    g25chartCategories: [],
    g25chartLoading: false,
    g25chartRunning: false,
    g25chartSeries: [],
    g25calcSeries: [],
    g25calcSampleSeries: [],
    g25calcSampleComponents: [],
    g25calcComponents: [],
    g25chartComponents: [],
    rawchartJSON: false,
    rawchartRefs: false,
    rawcalcJSON: false,
    rawchartColors: false,
    rawcalcColors: false,
    rawchartCategories: [],
    rawchartLoading: false,
    rawchartRunning: false,
    rawchartSeries: [],
    rawcalcSeries: [],
    rawcalcSampleSeries: [],
    rawcalcSampleComponents: [],
    rawcalcComponents: [],
    rawchartComponents: [],
    plotSwitches: {
        averaged: false,
        median: false,
        all: true
    },
    plotSurface: false,
    plotMesh: false,
    plotMode: false,
    screenshot: false,
    g25multiview: false,
    pcamultiview: false,
    admixmultiview: false,
    qpmultiview: false,
    g25showlast: false,
    pcashowlast: false,
    admixshowlast: false,
    qpshowlast: false,
    admixTools2: false,
    ahistory: true,
    plotStyle: {},
    plotSlider: {
        surfaceaxis: {
            value: 'off',
            data: ['off', 'z-axis', 'y-axis', 'x-axis']
        }
    },
    plotUserSamples: [],
    plotGroupSamples: [],
    plotCustomGroups: [],
    plotInterestedSamples: [],
    userSamples: [],
    editSamples: [],
    userCalcs: [],
    editCalcs: [],
    smallScreen: false,
    maxVals: false,
    maxRawVals: false,
    maxRefVals: false,
    g25chartKey: false,
    lastUpdate: false,
    userUpdated: false,
    countdown: false,
    appVisible: false,
    switches: {
        ...settings.switches
    },
    rswitches: {
        ...settings.switches
    },
    slider: {
        ...settings.slider
    },
    authflow: false,
    routeKey: 0,
    fstatsActiveJob: null
}
data.init = JSON.stringify(data);
export const store = createStore({
    state() {
        return data
    },
    mutations: {
        change(state, props) {
            var key = Object.keys(props)[0];
            var val = props[key];
            val = jsonstrings[key] && typeof(val) == 'object' && key != 'pcacustomsamples' && key != 'plotInterestedSamples' ? Object.freeze(val) : val
            if ( jsonstrings[key] === -101122 ) {
            console.log('setting memory map', key, val);
            window.g25cache[key] = val;
            } else {
            state[key] = val;
            }
        },
        increment(state, props) {
            var key = Object.keys(props)[0];
            var val = props[key];
            state[key]++
        }
    },
    getters: {
        get: (state) => (prop) => {
            if ( jsonstrings[prop] === -123 ) {
            console.log('getting memory map', prop);
            return window.g25cache[prop]
            } else {
            let data = state[prop]
            return data
            }
        }
    },
    plugins: [vuexPersist.plugin]
})
